import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { APP_CONFIG } from '../app-config';
import { IUserRepository } from './Iuser.repository';
import { ApiResponse, Dictionary, LegalDocument, LegalDocumentAcceptance, UserProfile, UserRequest } from './models';


@Injectable({ providedIn: 'root' })
export class UserRepository implements IUserRepository {

	private readonly config = inject(APP_CONFIG);
	private readonly httpClient = inject(HttpClient);


	// USER API - USERS
	getUserProfile(): Observable<ApiResponse<UserProfile>> {
		return this.httpClient.get<ApiResponse<UserProfile>>(this.config.domainUserAPI + '/api/users/GetUserProfile');
	}
	setDocumentsApproval(legalDocumentAccepted: LegalDocumentAcceptance[]): Observable<ApiResponse<any>> {
		return this.httpClient.post<ApiResponse<any>>(this.config.domainUserAPI + '/api/users/SetDocumentsApproval', legalDocumentAccepted);
	}

	// ADMIN API - REQUEST
	sendRequest(request: UserRequest, captchaToken: string): Observable<ApiResponse<any>> {
		const headers = new HttpHeaders({ 'X-Recaptcha-Token': captchaToken });
		return this.httpClient.post<ApiResponse<any>>(this.config.domainAdminAPI + '/api/request/User', request, { headers });
	}
	getLegalDocuments(countryCode: string, roleType: string): Observable<ApiResponse<LegalDocument[]>> {
		let params = new HttpParams().set('countryCode', countryCode).set('roleType', roleType);
		return this.httpClient.get<ApiResponse<LegalDocument[]>>(this.config.domainAdminAPI + '/api/request/LegalDocs', { params: params });
	}
	getDictionaries(nameList: string): Observable<ApiResponse<Dictionary[]>> {
		let params = new HttpParams().set('nameList', nameList);
		return this.httpClient.get<ApiResponse<Dictionary[]>>(this.config.domainAdminAPI + '/api/request/Dictionaries', { params: params });
	}
	getAzureMapsSasToken(captchaToken: string): Observable<ApiResponse<string>> {
		const headers = new HttpHeaders({ 'X-Recaptcha-Token': captchaToken });
		return this.httpClient.get<ApiResponse<string>>(this.config.domainAdminAPI + '/api/request/AzureMapsSas', { headers });
	}
}
